import React from 'react'
import finalYear from "../../../images/students/final-year.webp";
import campus from "../../../images/students/campus.webp";
import interview from "../../../images/students/interview.webp";

export default function ViralArticle() {
    return (
        <div className='text-center mb-[50px] xl:mb-[70px] relative z-0'>
            <h4 className='text-[#101828] font-semibold text-[22px] md:text-[32px] lg:text-[44px]'>THE VIRAL SK ARTICLE</h4>
            <p className='text-[#4A5565] font-normal text-[14px] md:text-[25px] mt-[11px]'>How to Get a Job — It’s a Mindshift, Not a Skill List.</p>
            <p className='text-[#4A5565] font-medium text-[20px] md:text-[26px] mt-[12px] md:mt-[20px]'>This article reached lakhs. Thousands wrote back saying it changed their life.</p>
            <div className='mt-[20px] md:mt-[64px] flex flex-wrap justify-center xl:grid xl:grid-cols-3 items-center gap-[20px] md:gap-[30px] w-full md:w-11/12 mx-auto'>
                <div className='w-full md:w-[345px] xl:w-auto h-full rounded-[12px] md:rounded-[26px] bg-[#FFF] border-[#F3F4F6] border p-[15px] md:p-[30px]' style={{ boxShadow: "0px 10px 15px -3px #0000001A" }}>
                    <img src={finalYear} alt='finalYear' loading='lazy' className='size-[100px] md:size-[160px] mx-auto'/>
                    <div className='mt-[10px] md:mt-[20px] text-start'>
                        <p className='text-[#101828] font-medium text-[22px] md:text-[30px] text-center'>Helped final-year students & Freshers</p>
                    </div>
                </div>
                <div className='w-full md:w-[345px] xl:w-auto h-full rounded-[12px] md:rounded-[26px] bg-[#FFF] border-[#F3F4F6] border p-[15px] md:p-[30px]' style={{ boxShadow: "0px 10px 15px -3px #0000001A" }}>
                    <img src={campus} alt='campus' loading='lazy' className='size-[100px] md:size-[160px] mx-auto'/>
                    <div className='mt-[10px] md:mt-[20px] text-start'>
                        <p className='text-[#101828] font-medium text-[22px] md:text-[30px] text-center'>Supported Tier 2 & 3 students</p>
                    </div>
                </div>
                <div className='w-full md:w-[345px] xl:w-auto h-full rounded-[12px] md:rounded-[26px] bg-[#FFF] border-[#F3F4F6] border p-[15px] md:p-[30px]' style={{ boxShadow: "0px 10px 15px -3px #0000001A" }}>
                    <img src={interview} alt='interview' loading='lazy' className='size-[100px] md:size-[160px] mx-auto'/>
                    <div className='mt-[10px] md:mt-[20px] text-start'>
                        <p className='text-[#101828] font-medium text-[22px] md:text-[30px] text-center'>Encouraged those afraid of interviews</p>
                    </div>
                </div>
            </div>
        </div>
    )
}
